<section class="dashboard">
  <div class="dashboard-header">
    <div class="user-info">
      <img [src]="user.picture" alt="user avatar" class="avatar" />
      <div>
        <h2>{{ user.nickname }}</h2>
        <p>{{ user.email }}</p>
      </div>
    </div>
    <div class="settings">
      <button class="icon-btn"><i class="ph ph-gear"></i></button>
    </div>
  </div>

  <div class="insights-header">
    <div class="title-group">
      <h3>Account Management</h3>
      <p>Manage users and sites for each client account</p>
    </div>
  </div>

  <div class="stats-grid">
    <div class="stat-card">
      <h3>Total Accounts</h3>
      <p class="value">{{ accounts.length }}</p>
    </div>
    <div class="stat-card">
      <h3>Total Users</h3>
      <p class="value">{{ totalUserCount }}</p>
    </div>
    <div class="stat-card">
      <h3>Total Sites</h3>
      <p class="value">{{ totalSiteCount }}</p>
    </div>
  </div>

  <app-admin-grid
    title="Accounts"
    [entityLabel]="'Account'"
    [columns]="columns"
    [data]="accounts"
    (rowClicked)="openAccount($event)"
    (addClicked)="addAccount()"
    (editClicked)="editAccount($event)"
    (deleteClicked)="deleteAccount($event)">
  </app-admin-grid>
</section>
